import type { IconType } from "react-icons";
import { FaRegFolderOpen } from "react-icons/fa";
import { formatDate } from "../utils/date";

interface DateRangeEmptyStateProps {
    title?: string;
    startDate?: string;
    endDate?: string;
    icon?: IconType;
    message?: string;
}

export const DateRangeEmptyState = ({
    title = "No expenses found",
    startDate,
    endDate,
    icon: Icon = FaRegFolderOpen,
    message = "Try selecting a different date range.",
}: DateRangeEmptyStateProps) => {
    const dateRange =
        startDate && endDate
            ? ` from ${formatDate(startDate)} to ${formatDate(endDate)}`
            : startDate
                ? ` from ${formatDate(startDate)}`
                : endDate
                    ? ` up to ${formatDate(endDate)}`
                    : "";

    return (
        <div className="flex min-h-[240px] flex-col items-center justify-center px-6 py-12 text-center">
            <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-blue-50 text-blue-600">
                {Icon({ size: 20 })}
            </div>

            <h3 className="text-sm font-semibold text-slate-700">
                {title}
            </h3>

            <p className="mt-2 max-w-sm text-xs leading-5 text-slate-400">
                {`No records were found${dateRange}.`} {message}
            </p>
        </div>
    );
};